import React from 'react';
export function ValueStack() {
  const bonuses = ['Calculadora de Precios PRO', 'Recetario Postres Rentables', 'Instagram Vende Express', 'Directorio de Proveedores', 'Pack 30 Stories Listas', 'Fotos Celular Estilo Pro', 'Ruta Negocio 7 Días', 'Actualizaciones Eternas'];
  return <section className="bg-bg3 py-16 px-5" data-id="element-156">
      <div className="container-custom" data-id="element-157">
        <span className="section-tag text-center mx-auto" data-id="element-158">
          La cuenta es simple
        </span>
        <h2 className="section-title text-center mb-9" data-id="element-159">
          TODO LO QUE RECIBÍS HOY
        </h2>

        <div className="bg-card border border-border rounded-2xl overflow-hidden max-w-[580px] mx-auto" data-id="element-160">
          <div className="flex justify-between items-center p-[14px_28px] border-b border-border text-[14px]" data-id="element-161">
            <span className="text-muted" data-id="element-162">
              Método Completo +30 Diseños Artísticos 3D
            </span>
            <span className="text-text font-medium" data-id="element-163">$49.999</span>
          </div>

          {bonuses.map((bonus, idx) => <div key={idx} className="flex justify-between items-center p-[14px_28px] border-b border-border text-[14px]" data-id="element-164">
              <span className="text-text" data-id="element-165">🎁 {bonus}</span>
              <span className="text-green font-bold text-[12px]" data-id="element-166">GRATIS</span>
            </div>)}

          <div className="p-[20px_28px] border-b border-border" data-id="element-167">
            <div className="flex justify-between items-center" data-id="element-168">
              <span className="text-[16px] font-bold text-white" data-id="element-169">
                Valor total real
              </span>
              <span className="text-[16px] font-medium text-muted line-through" data-id="element-170">
                +$192.000 ARS
              </span>
            </div>
          </div>

          <div className="p-7 text-center" data-id="element-171">
            <div className="text-[14px] text-muted mb-1" data-id="element-172">Tu inversión hoy:</div>
            <div className="font-bebas text-[64px] text-gold leading-none mb-2" data-id="element-173">
              $14.999 <small className="text-[28px] font-sans" data-id="element-174">ARS</small>
            </div>
            <div className="text-[13px] text-muted mb-5" data-id="element-175">
              Pago único · Sin cuotas · Acceso de por vida
            </div>
            <a href="[CART_LINK]" className="cta-primary block w-full" data-id="element-176">
              AGREGAR AL CARRITO →
            </a>
          </div>
        </div>
      </div>
    </section>;
}